module.exports = __webpack_public_path__ + "static/media/EIR-graph.ffc4fbfa.png";